import React, { Component } from "react";
import PropTypes from "prop-types";

class Logo extends Component {
    render() {
        let styleVal = {};
        if (this.props.center) {
            styleVal = { display: "block", margin: "auto auto" };
        }
        if (this.props.width) styleVal.width = this.props.width + "px";
        if (this.props.height) styleVal.height = this.props.height + "px";
        if (this.props.padding) styleVal.padding = this.props.padding + "px";

        let pathPrefix = this.props.pathPrefix ? this.props.pathPrefix : "";
        let logoPath = pathPrefix + "logo-inumet.png";
        if (this.props.blancoTransp) {
            logoPath = pathPrefix + "logo_inumet_blanco_transp.png";
        } else if (this.props.logoConFondoIcono) {
            logoPath = pathPrefix + "splash_screen_land.png";
        }

        return <img style={styleVal} alt="Logo INUMET" src={logoPath} />;
    }
    //<strong style={{position:"absolute", bottom:0}}>    <b>admin</b></strong>
}

Logo.propTypes = {
    center: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    padding: PropTypes.number,
    pathPrefix: PropTypes.string,
    blancoTransp: PropTypes.bool,
    logoConFondoIcono: PropTypes.bool,
};

export default Logo;
